/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { JSCall } from '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

/**
 * 该方法会彻底拦截掉容器左上角的默认回退。
 */
function onBackCatcher(cb) {
    var handler = function () {
        if (typeof cb !== 'function') {
            return;
        }
        cb();
    };
    JSCall('CNHybridNavigator.registerNativeGoBackCatcher', {}, function () {
        document.addEventListener('cnBack', handler, false);
    });
    return function () { return JSCall('CNHybridNavigator.unregisterNativeGoBackCatcher', {}); };
}

export { onBackCatcher as default };
